import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Components
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ContactModal from './components/common/ContactModal';
import ScrollToTop from './components/common/ScrollToTop';

// Company Pages
import AboutUsPage from './pages/company/AboutUsPage';
import OurEvolutionPage from './pages/company/OurEvolutionPage';
import WhatWeOfferPage from './pages/company/WhatWeOfferPage';
import TimelinePage from './pages/company/TimelinePage';

// Careers Pages
import WorkingInExessDPage from './pages/careers/WorkingInExessDPage';
import OpenPositionsPage from './pages/careers/OpenPositionsPage';
import InternshipProgramPage from './pages/careers/InternshipProgramPage';

// Other Pages
import GatewayToIndiaPage from './pages/GatewayToIndiaPage';
import EngineeringPage from './pages/EngineeringPage';
import OurServicesPage from './pages/OurServicesPage';

// Context
import { AppProvider } from './context/AppContext';

function App() {
  return (
    <AppProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-white">
          <Header />

          <main className="flex-grow">
            <Routes>
              {/* Company Routes */}
              <Route path="/company/about-us" element={<AboutUsPage />} />
              <Route path="/company/our-evolution" element={<OurEvolutionPage />} />
              <Route path="/company/what-we-offer" element={<WhatWeOfferPage />} />
              <Route path="/company/timeline" element={<TimelinePage />} />

              {/* Engineering */}
              <Route path="/engineering" element={<EngineeringPage />} />

              {/* Our Services */}
              <Route path="/our-services" element={<OurServicesPage />} />

              {/* Gateway to India */}
              <Route path="/gateway-to-india" element={<GatewayToIndiaPage />} />

              {/* Careers Routes */}
              <Route path="/careers/working-in-excessd" element={<WorkingInExessDPage />} />
              <Route path="/careers/open-positions" element={<OpenPositionsPage />} />
              <Route path="/careers/internship-program" element={<InternshipProgramPage />} />

              {/* Default redirects */}
              <Route path="/company" element={<Navigate to="/company/about-us" replace />} />
              <Route path="/careers" element={<Navigate to="/careers/working-in-excessd" replace />} />
              <Route path="*" element={<Navigate to="/company/about-us" replace />} />
            </Routes>
          </main>

          <Footer />
          <ContactModal />
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;